let recaptchaKey = '';

const initRecaptcha = () => {
  if (!recaptchaKey) {
    recaptchaKey = window.VUE_APP_RECAPTCHA_V3_KEY;
    console.log('recaptchaKey = '+recaptchaKey);
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
    script.async = true;
    document.head.appendChild(script);
  }
};

const checkRecaptcha = () => {
  return new Promise((resolve) => {
    grecaptcha.ready(() => {
        console.log('recaptchaKey = '+recaptchaKey);
      grecaptcha.execute(recaptchaKey, {action: 'submit'}).then((token) => {
        resolve(token);
      });
    });
  });
};

export default {
  install(Vue) {
    Vue.prototype.$initRecaptcha = initRecaptcha;
    Vue.prototype.$checkRecaptcha = checkRecaptcha;
  }
};